import { useState, useEffect } from 'react';
import { BigObjectiveRollUp } from '@amzn/merp-core/models';
import { rollUpService } from '../services';

export function useBigObjectiveRollUps() {
    const [loading, updateLoading] = useState(false);
    const [rollUps, updateRollUps] = useState<BigObjectiveRollUp[]>([]);

    useEffect(() => {
        async function fetchRollUps() {
            updateLoading(true);

            const response = await rollUpService.getBigObjective();

            updateRollUps(response.succeeded ? response.result! : []);
            updateLoading(false);
        }

        fetchRollUps();
    }, [updateRollUps, updateLoading]);

    return { rollUps, loading };
}
